<script lang="ts">
  import type { Snippet } from "svelte"

  type Props = {
    class?: string | null
    children?: Snippet
  }

  let { class: cssClass = undefined, children }: Props = $props()
</script>

<p class="alert-body text-general-default-text font-medium-400 {cssClass}">
  {@render children?.()}
</p>
